<template>
  <v-list dense class="pt-0">
      <v-list style="height: 110px;">
        <v-list-tile>
          <v-list-tile-title class="title logoPosition">
            <img :src="`${path}/public/logo.png`" height="100px" />
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>

      <v-list>
        <v-list-group 
        no-action
        v-for="(roles,index) in getMenuList"        
        :key="index"  
        :value="roles.active"
        >        
          <template v-slot:activator>         
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ roles.menu_name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </template>

          <div
          v-for="(menuNames, subIndex) in roles.sub_menu"
          value="true"
          :key="subIndex"           
          >
             <!-- :class="[activeItem == menuNames.submenu_name ? activeClass : '']" -->
             <!-- active-class="green--text activeMenu_v"  -->
            <!-- class="testing"   -->
          <!-- <div :class="[activeItem ? activeClass : '', errorClass]">       -->
          <v-list-tile                    
          slot="menuNames.url" 
          @click="triggerRoute(menuNames.url, menuNames,menuNames.submenu_name, roles.menu_name)"
          :to="menuNames.url == '#' ? '' : menuNames.url" 
          :exact="menuNames.exact" 
          :class="[activeItem == menuNames.submenu_name ? activeClass : 'listMenu']"
          >

          <v-list-tile-action>
           <v-icon class="activeIcon">{{ menuNames.action }}</v-icon>
          </v-list-tile-action>
         <v-list-tile-content>
          <v-list-tile-title>{{ menuNames.submenu_name }}</v-list-tile-title>
        </v-list-tile-content>

        
      </v-list-tile>
    </div>
  </v-list-group>
</v-list>
</v-list>
</template>

<script>
import ServerPath from "../server-path/server-path";
let Encrypted = require("../services/encrypted");
import {FrontendPath} from '../vuex/api'

export default {
  data() {
    return {
      active:true,
      
      activeItem: "Admin Dashboard", // For menu activation
      activeClass:'activeMenu',

      clipped: false,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "IPFF II",

      menu_name: "",
      submenu_id: 0,
      submenu_list: [],
      menu_list: [],
      path: FrontendPath,
    };
  },
  created: function() {
    
    this.checkMenu();
    if (sessionStorage.getItem("auth") == "yes") {
      this.menu_list = JSON.parse(Encrypted.base64_decode(localStorage.getItem("roleDetails")));
      //this.menu_list = JSON.parse(localStorage.getItem("roleDetails"));
      this.$store.commit("SET_USER_ROLE_DATA", this.menu_list);
    } else this.menu_list = this.getMenuList;
  },

  methods: {

    triggerRoute: function(path, data, menuActive, module_name) {
      //console.log('data', data);
      
      this.$store.commit('SET_MODULE_NAME',module_name);

      localStorage.setItem("module", module_name);
      this.setActive(data, menuActive); // For menu activation

      let rolesData = {
        read: data.read,
        save: data.save,
        update: data.update,
        delete: data.delete
      };

      let encodeString = Encrypted.base64_encode(JSON.stringify(rolesData));
      sessionStorage.setItem("p", encodeString);      

      let decodeString = Encrypted.base64_decode(sessionStorage.getItem("p"));
      this.$store.commit("SET_USER_ROLE", JSON.parse(decodeString));

      //this.$router.push({ path: path });
      this.$store.commit('UNSET_COMMON_DATA');
      this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
    },

    // For menu activation
    isActive: function(menuItem) {
      return this.activeItem === menuItem;
    },
    
    setActive: function(data, menuItem) {
      sessionStorage.setItem("ActiveMenu", menuItem);

      sessionStorage.removeItem('mm_id')
      sessionStorage.removeItem('loan_s')
      sessionStorage.removeItem('sm_id') 
      sessionStorage.setItem("mm_id", data.mm_id);
      //sessionStorage.setItem("mm_id", data.id);
      sessionStorage.setItem("sm_id", data.submenu_id);
      
      this.activeItem  = menuItem;
    },
    checkMenu: function() {
      var exixtMenu = sessionStorage.getItem("ActiveMenu");      
      if (exixtMenu) {
        this.activeItem = exixtMenu;
      }
    } // End menu activation
  },
  computed: {
    getMenuList: function() {
     let getMainMenuList = this.$store.getters.getUserRoleDetails
     let currentMenu = this.$store.getters.GET_KEY_VALUE
     
     //let currentMenu = localStorage.getItem("module");
     getMainMenuList.forEach((mymenu) => {
      if(mymenu.menu_name == currentMenu){
        mymenu.active = true
      }else{
       mymenu.active = false
     }
   })
     return this.$store.getters.getUserRoleDetails;
   }
 }
};
</script>

<style scoped>
.logoPosition {
  height: 110px;
  text-align: center;
  margin-top: 56px;
}


</style>


// WEBPACK FOOTER //
// src/components/sidebar.vue